import { Button, Card, Col, Row } from 'components/ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import i18n from '../../../../i18n'; // eslint-disable-line
import { Trans } from 'react-i18next';

const Step03Header = () => (
	<Card.Title>
		<Trans
			i18nKey='impfschaeden.erfassen.impfschaden_selbst_betroffen'
			components={{ italic: <i /> }}
		/>
	</Card.Title>
);

const Step03 = (props) => {
	const [t] = useTranslation(['translation']);
	return (
		<>
			<Step03Header />
			<Row style={{ marginTop: '20px' }}>
				<Col xs={12} md={3} style={{ marginTop: '10px' }}></Col>
				<Col xs={12} md={3} style={{ marginTop: '10px' }}>
					<Button
						variant='primary'
						size='lg'
						onClick={props.nextToSamePers}
						style={{ height: '120px', width: '100%' }}
					>
						{t('impfschaeden.erfassen.meinen_impfschaden_erfassen')}
					</Button>
				</Col>
				<Col xs={12} md={3} style={{ marginTop: '10px' }}>
					<Button
						variant='primary'
						size='lg'
						onClick={props.nextToAnotherPers}
						style={{ height: '120px', width: '100%' }}
					>
						{t('impfschaeden.erfassen.impfschaden_von_jemand_anderem_erfassen')}
					</Button>
				</Col>
				<Col xs={12} md={3}></Col>
			</Row>
		</>
	);
};

Step03.propTypes = {
	nextToSamePers: PropTypes.func,
	nextToAnotherPers: PropTypes.func,
	edit: PropTypes.bool,
};

export default Step03;
